import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class NbCardService {

  private subject = new Subject<boolean>();

  // cardSizeChanged$ = this.cardSizeChangeSource.asObservable();

  // Subscription examples:
  // http://jasonwatmore.com/post/2016/12/01/angular-2-communicating-between-components-with-observable-subject

  cardSizeChange(fullscreen: boolean) {
    this.subject.next(fullscreen);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/framework/theme/components/card/card.service.ts